<template>
  <q-page fluid>
    <div class="row q-col-gutter-x-md dashboard full-width">
      <div class="col q-pa-lg">
        <div class="row q-col-gutter-md">
          <div class="col-12">
            <q-card
              v-if="$q.screen.gt.md"
              flat
              class="full-height dashboardBanner q-pa-lg"
            >
              <div class="row full-height items-center">
                <div class="col-auto q-mr-lg">
                  <img
                    src="https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/Oatas+Icon-13.svg"
                    alt="Mini logo"
                    class="smallImage q-mx-auto q-my-auto"
                    width="60px"
                    height="60px"
                  />
                </div>
                <div class="col">
                  Welcome to <b>Oatas</b>, we are excited to have you along with
                  us for the journey <br />
                  We are currently in an Open Beta so please feel free to give
                  feedback
                  <a
                    href="https://form.jotform.com/223346499025056"
                    target="_blank"
                    class="text-accent"
                    >here</a
                  >
                </div>
              </div>
            </q-card>
          </div>
          <div class="col">
            <q-card flat class="bg-grey-2 full-height">
              <q-card-section>
                <h3 class="cardHeader" style="display: inline-block">
                  Your Current Plans
                </h3>
              </q-card-section>
              <q-card-section class="q-pt-none">
                <div class="row q-col-gutter-md">
                  <div class="col-auto">
                    <q-card
                      flat
                      class="planCard cursor-pointer"
                      style="background: #797979"
                      @click="$router.push('/outcomePlans')"
                    >
                      <div class="row items-center full-height">
                        <div class="col-12 text-center text-white">
                          <q-icon
                            name="mdi-format-list-checks"
                            size="60px"
                            class=""
                            color="white"
                          ></q-icon>
                          <p class="q-mb-none">
                            Create <br />
                            a Plan
                          </p>
                        </div>
                      </div>
                    </q-card>
                  </div>
                  <div
                    v-if="outcomePlans.length != 0"
                    v-for="(plan, index) in outcomePlans"
                    :key="`plan_${index}`"
                    class="col-auto"
                  >
                    <q-card
                      flat
                      class="planCard cursor-pointer"
                      :style="`background: ${plan.primaryColor}`"
                      @click="
                        $router.push(`/outcomePlans/outcome/${plan.outcome_id}`)
                      "
                    >
                      <div class="row items-center full-height">
                        <div class="col-12 text-center text-white">
                          <q-img
                            :src="getWhiteOutcomeImage(plan)"
                            class="planOutcomeImage q-mb-xs"
                          ></q-img>
                          <p class="q-mb-none q-px-sm">{{ plan.label }}</p>
                        </div>
                      </div>
                    </q-card>
                  </div>
                  <div class="col text-center" v-if="outcomePlans.length == 0">
                    <b class="text-primary">You haven't got any plans yet!</b>
                    <p class="text-accent2">
                      Start your sustainability journey by clicking <br />
                      'Create a Plan'
                    </p>
                  </div>
                </div>
              </q-card-section>

              <!-- <q-btn
                @click="$router.push('/outcomePlanQuestionnaire/outcome/1')"
              >
                Create a Plan
              </q-btn> -->
            </q-card>
          </div>
          <div class="col-auto">
            <q-card flat class="bg-grey-2 full-height" style="width: 300px">
              <q-card-section>
                <h3 class="cardHeader">Latest Insights</h3>
              </q-card-section>
              <q-card-section>
                <div class="row items-center">
                  <div class="col"></div>
                  <div class="col-auto" v-if="outcomePlans.length == 0">
                    <p
                      class="text-accent2 text-center"
                      style="max-width: 200px"
                    >
                      <b>We are eager to show you your progress</b> as you start
                      your sustainability plans
                    </p>
                  </div>
                  <div class="col-auto" v-else>
                    <p class="q-my-none">You have started creating plans for</p>
                    <h3 class="cardHeader">
                      {{ outcomePlans.length }} Outcomes
                    </h3>
                    <p class="q-my-none">and saved a total of</p>
                    <h3 class="cardHeader text-primary">
                      {{ solutionsList.length }} Solutions
                    </h3>
                  </div>
                  <div class="col"></div>
                </div>
              </q-card-section>
            </q-card>
          </div>

          <div class="col-12">
            <div class="row q-gutter-x-md" style="min-height: 300px">
              <div class="col">
                <q-card flat class="bg-grey-2 full-height full-width">
                  <q-card-section>
                    <div class="row items-center">
                      <div class="col">
                        <h3 class="cardHeader">Your Recent Stories</h3>
                      </div>
                      <div class="col-auto">
                        <q-btn
                          :disable="currentStoryCard == 0"
                          @click="currentStoryCard -= 1"
                          round dense flat
                          icon="mdi-chevron-left"
                        ></q-btn>
                        <q-btn
                          round dense flat
                          icon="mdi-chevron-right"
                          :disable="currentStoryCard == storyCards.length - 1"
                          @click="currentStoryCard += 1"
                        ></q-btn>
                      </div>
                    </div>
                  </q-card-section>
                  <q-card-section
                    class="q-px-none q-pt-none q-pb-md"
                  >
                    <div class="row items-center">
                      <div class="col text-center"></div>
                      <div
                        class="col-auto cursor-pointer"
                        v-if="storyCards.length > 0"
                        @click="
                          $router.push(
                            `outcomePlans/outcome/${storyCards[currentStoryCard].outcome_id}/storySummary/${storyCards[currentStoryCard].id}`
                          )
                        "
                      >
                        <storyCard
                          :largeVersion="$q.screen.gt.lg"
                          :data="storyCards[currentStoryCard]"
                        />
                      </div>
                      <div
                        class="col-auto text-center"
                        style="max-width: 200px"
                        v-else
                      >
                        <p class="text-accent2">
                          <b>We can't wait to show you your stories.</b> When
                          you start creating stories, you'll be able to see a
                          snapshot here
                        </p>
                      </div>
                      <div class="col text-center"></div>
                    </div>
                    <div class="row items-center">
                      <div class="col flex justify-end q-mt-md q-mr-md">
                        <q-btn class="text-white q-pr-sm" style="background-color: #162C47" @click="openNewStoryCreateDialogue" dense icon="mdi-plus">
                          Create story
                        </q-btn>
                      </div>
                    </div>
                  </q-card-section>
                </q-card>
              </div>
              <div class="col">
                <q-card flat class="bg-grey-2 full-height full-width">
                  <q-card-section>
                    <div class="row items-center">
                      <div class="col">
                        <h3 class="cardHeader">Your Recent Solutions</h3>
                      </div>
                      <div class="col-auto">
                        <q-btn
                          :disable="currentSolution == 0"
                          @click="currentSolution -= 1"
                          round
                          dense
                          flat
                          icon="mdi-chevron-left"
                        ></q-btn>
                        <q-btn
                          round
                          dense
                          flat
                          icon="mdi-chevron-right"
                          :disable="currentSolution == solutionsList.length - 1"
                          @click="currentSolution += 1"
                        ></q-btn>
                      </div>
                    </div>
                  </q-card-section>
                  <q-card-section
                    class="q-px-none q-pt-none q-pb-sm"
                    style="height: calc(100% - 66px)"
                  >
                    <div class="row items-center" style="height: 100%">
                      <div class="col text-center"></div>
                      <div
                        class="col-auto cursor-pointer"
                        v-if="solutionsList.length > 0"
                        @click="
                          $router.push(
                            `/solutionsDatabase/${solutionsList[currentSolution].id}`
                          )
                        "
                      >
                        <solution-card
                          :largeVersion="$q.screen.gt.lg"
                          :data="solutionsList[currentSolution]"
                        />
                      </div>
                      <div
                        class="col-auto text-center"
                        style="max-width: 200px"
                        v-else
                      >
                        <p class="text-accent2">
                          <b>When you start saving solutions</b> that achieve
                          your sustainability goals, we look forward to
                          showcasing some of them here
                        </p>
                      </div>
                      <div class="col text-center"></div>
                    </div>
                  </q-card-section>
                </q-card>
              </div>
              <div class="col">
                <q-card flat class="bg-grey-2 full-height full-width">
                  <q-card-section>
                    <div class="row items-center">
                      <div class="col">
                        <h3 class="cardHeader">Recent Articles</h3>
                      </div>
                      <div class="col-auto">
                        <q-btn
                          :disable="currentArticle == 0"
                          @click="currentArticle -= 1"
                          round
                          dense
                          flat
                          icon="mdi-chevron-left"
                        ></q-btn>
                        <q-btn
                          round
                          dense
                          flat
                          icon="mdi-chevron-right"
                          :disable="currentArticle == articlesList.length - 1"
                          @click="currentArticle += 1"
                        ></q-btn>
                      </div>
                    </div>
                  </q-card-section>
                  <q-card-section
                    class="q-px-none q-pt-none q-pb-sm"
                    style="height: calc(100% - 66px)"
                  >
                    <div class="row items-center" style="height: 100%">
                      <div class="col text-center"></div>
                      <div
                        class="col-auto cursor-pointer"
                        @click="
                          $router.push(
                            `/researchAndInsightsView/${articlesList[currentArticle].id}`
                          )
                        "
                      >
                        <article-card-preview
                          :largeVersion="$q.screen.gt.lg"
                          :data="articlesList[currentArticle]"
                        />
                      </div>

                      <div class="col text-center"></div>
                    </div>
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-auto">
        <q-card
          class="bg-grey-2"
          flat
          style="height: calc(100vh - 60px); width: 310px"
        >
          <q-card-section>
            <h2 class="cardHeaderH2 q-pt-lg">
              Hi {{ currentUserData.fullName.split(" ")[0] }}, <br />
            </h2>
            <h2 class="cardHeaderH2 text-primary">
              {{ generateGreetings() }}
            </h2>
            <p class="text-accent2 q-mt-lg" style="line-height: 1rem">
              We're excited to help get
              <span style="font-size: 1.2rem; font-weight: bold">{{
                currentUserData.sustainabilityBusiness_name
              }}</span>
              started
            </p>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <q-dialog
      v-if="isCreatingNewStory"
      v-model="isCreatingNewStory"
      persistent
      max-width="90vw"
    >
        <StoryCardForm
          :is-creating-new-story-from-anywhere="true"
          :close-function="closeNewStoryCreateDialogue"
        />
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { getOutcomeImage } from "@/functions/getOutcomeImage";
import { getWhiteOutcomeImage } from "@/functions/getWhiteOutcomeImage";
import storyCard from "@/components/storyCards/storyCard.vue";
import solutionCard from "@/components/solutions/solutionCard.vue";
import StoryCardForm from "@/components/storyCards/storyCardForm.vue";

import articleCardPreview from "@/components/articles/articleCardPreview.vue";

export default {
  components: { storyCard, solutionCard, articleCardPreview, StoryCardForm },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      outcomePlans: "businessOutcomePlans/list",
      storyCards: "storyCard/listOrderedByRecent",
      solutionsList: "solutions/business/listRecentSelected",
      articlesList: "articles/listRecent",
    }),
  },
  watch: {},
  data: () => ({
    currentStoryCard: 0,
    currentSolution: 0,
    currentArticle: 0,
    shownStoryCard_id: null,
    isCreatingNewStory: false,
  }),
  mounted() {
    this.$store.dispatch("outcomes/loadAll").then(() => {
      this.$store.dispatch("articles/loadAll");
    });
    this.$store.dispatch("businessOutcomePlans/loadAll");
    this.$store.dispatch("storyCard/loadAll");
    this.$store.dispatch("solutions/business/loadRecentSelected");
  },
  methods: {
    getWhiteOutcomeImage: getWhiteOutcomeImage,
    momentPeriod() {
      const hour = moment().hour();

      if (hour > 17) {
        return "evening";
      }

      if (hour > 11) {
        return "afternoon";
      }

      return "morning";
    },
    openNewStoryCreateDialogue() {
      this.isCreatingNewStory = true;
    },
    closeNewStoryCreateDialogue() {
      this.isCreatingNewStory = false;
      this.$store.dispatch("storyCard/loadAll").then(() => this.currentStoryCard = 0);
    },
    generateGreetings() {
      var currentHour = moment().format("HH");

      if (currentHour >= 3 && currentHour < 12) {
        return "Good Morning";
      } else if (currentHour >= 12 && currentHour < 15) {
        return "Good Afternoon";
      } else if (currentHour >= 15 && currentHour < 20) {
        return "Good Evening";
      } else if (currentHour >= 20 || currentHour < 3) {
        return "Good Night";
      } else {
        return "Hello";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  .cardHeader {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 800;
    font-size: 1.1rem;
    line-height: 29px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent2;
    margin: 0px 0px;
  }
  .cardHeaderH2 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 800;
    font-size: 1.5rem;
    line-height: 1.7rem;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: $accent2;
    margin: 0px 0px;
  }

  .planCard {
    height: 105px;
    width: 105px;
    border-radius: 20px;
    transition: box-shadow 250ms;
    font-size: 12px;
    line-height: 14px;
    font-weight: 700;

    &:hover {
      box-shadow: 0px 0px 15px 0px #c4c4c4 !important;
    }

    .planOutcomeImage {
      height: 58px;
      width: 58px;
    }
  }

  .cardSubHeading {
    font-family: "Open Sans", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    /* identical to box height */

    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    margin: 0px;
  }
}

.text-heading {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 2rem;
  line-height: 29px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
}

.text-subheading {
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 22px;
  /* identical to box height */

  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
}

.sustainability-card-heading {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #162c47;
}

.your-actions-body {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 9.87557px;
  line-height: 13px;
  color: #162c47;
}

.statistics-date {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;
  text-align: right;
  letter-spacing: 0.44px;

  /* Dark Color */

  color: #263238;
}

.sustainability-button {
  width: 151px;
  height: 34px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 9px;
  line-height: 11px;
  display: flex;
  align-items: center;
  text-align: center;
}

.dashboardBanner {
  min-height: 120px;
  background-color: #c8d8dd;
}
</style>
